/* src/app/components/doc-viewer-new/doc-viewer-content/doc-viewer-redaction-content/doc-viewer-redaction-content.component.scss */
:host {
  height: 100%;
}
iframe {
  flex: auto;
  border: 0px;
}
.content {
  background-color: #f5f5f5;
}
.button-icon {
  --fa-primary-color: rgb(159 168 218 / 86%);
  --fa-secondary-color: rgb(36, 62, 144);
  --fa-secondary-opacity: 1 ;
}
.button-disabled {
  --fa-primary-color: rgba(193, 194, 201, 0.86);
  --fa-secondary-color: #757474;
  --fa-secondary-opacity: 1 ;
}
.edit-box {
  background-color: gray;
  opacity: 0.5;
  position: absolute;
  margin: 0px;
  border: 1px solid black;
  z-index: 1;
  cursor: crosshair;
}
.resize-handle {
  width: 5px;
  height: 5px;
  background-color: white;
  border: 1px solid black;
}
.rh-top-left {
  position: absolute;
  top: 0;
  cursor: nw-resize;
  margin-top: -7px;
  margin-left: -7px;
}
.rh-top-right {
  position: absolute;
  top: 0;
  right: 0;
  cursor: ne-resize;
  margin-top: -7px;
  margin-right: -7px;
}
.rh-bottom-right {
  position: absolute;
  bottom: 0;
  right: 0;
  cursor: se-resize;
  margin-bottom: -7px;
  margin-right: -7px;
}
.rh-bottom-left {
  position: absolute;
  bottom: 0;
  cursor: sw-resize;
  margin-bottom: -7px;
  margin-left: -7px;
}
.redaction-edit-text {
  text-align: center;
  white-space: nowrap;
  overflow: visible;
  margin-top: 5px;
}
.annotation-edit-text {
  text-align: left;
  overflow: hidden !important;
  text-overflow: clip;
  height: 90%;
  white-space: break-spaces;
  margin: 5px;
}
.disable-select {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.disable-drag {
  -webkit-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
}
.paper-sized-card {
  border-top: 1px;
  width: 816px;
  height: 428px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
}
.disable-mouse-events {
  pointer-events: none;
}
.loading-status ::ng-deep .mat-mdc-progress-spinner circle,
.mat-mdc-progress-spinner circle {
  stroke: #FFC107;
}
.redact-button-container {
  border-radius: 4px;
  transition: box-shadow 0.3s;
}
.redact-button-container:hover {
  position: relative;
  box-shadow: 0px 0px 2px 2px rgba(225, 179, 0, 0.8);
}
.redact-entire-page {
  border: unset;
  color: white;
  cursor: pointer;
  background: #303f9f;
  border-radius: 4px;
  padding: 4px 16px;
  height: 28px;
  box-shadow: inset 0px 0px 0px 1px #1a237e;
  transition: box-shadow 0.4s;
}
:host-context(.dark-theme) .content {
  background-color: inherit;
}
:host-context(.dark-theme) .button-icon {
  --fa-primary-color: rgba(218, 209, 159, 0.86);
  --fa-secondary-color: rgb(255, 193, 7);
  --fa-secondary-opacity: 1;
}
:host-context(.dark-theme) .button-disabled {
  --fa-primary-color: rgba(193, 194, 201, 0.86);
  --fa-secondary-color: #757474;
  --fa-secondary-opacity: 1 color: #575757;
}
:host-context(.dark-theme) .redact-button-container:hover {
  background: rgba(20, 15, 0, 0.7);
  box-shadow: 0px 0px 2px 2px rgba(225, 179, 0, 0.8);
}
:host-context(.dark-theme) .redact-entire-page {
  background: rgba(20, 15, 0, 0.7);
  box-shadow: inset 0px 0px 0px 1px rgba(225, 225, 225, 0.5);
  transition: box-shadow 0.4s;
}
/*# sourceMappingURL=doc-viewer-redaction-content.component.css.map */
